module.exports = __webpack_public_path__ + "static/media/chip-100.7c9bc36f.png";